import axios from 'axios';

import { API_URL, LOCAL_STORAGE_KEY__ACCESS_TOKEN } from '@/constants';
import { authStore } from '@/stores';
import { reloadApp } from '@/utils/reload';

const defaultTimeout = 30000;
const defaultBaseURL = API_URL;

// Arrays must become repeated keys (a=1&a=2). `new URLSearchParams(obj)`
// alone stringifies them as "1,2", which the backend does not parse.
const stringifyParams = (params: Record<string, unknown>): string => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (Array.isArray(v)) {
      v.forEach((item) => {
        sp.append(k, String(item));
      });
    } else if (v !== null && v !== undefined) sp.append(k, String(v));
  });
  return sp.toString();
};

export const request = (settings: any) => {
  const {
    method = 'get',
    url,
    baseURL = null,
    data = {},
    headers = {},
    timeout = defaultTimeout,
    params = {},
    withCredentials = false,
    config = {},
  } = settings;

  let cancelToken: any;
  const token = localStorage.getItem(LOCAL_STORAGE_KEY__ACCESS_TOKEN);

  const instance = axios.create({
    baseURL: baseURL || defaultBaseURL,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
      Authorization: `Bearer ${token}`,
    },
    timeout,
    withCredentials,
    cancelToken: new axios.CancelToken((c) => (cancelToken = c)),
    paramsSerializer: (params1: any): string => stringifyParams(params1),
    ...config,
  });

  return {
    cancel: cancelToken,
    source: instance
      .request({ url, method, params, data })
      .then(({ data }: any) => data)
      .catch((e) => {
        if (e?.response) {
          const response: any = e.response;

          if (response.data?.error) {
            const error = response.data.error;
            // Session Expired
            if (error.code === 6) {
              reloadApp();
            }
          }

          if (response.status === 401) {
            authStore.logout();
            reloadApp();
          }
        }
        throw e;
      }),
  };
};
